import { ValidationException } from "./validation-exception";

export class ProcessLockException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'ProcessLockException';
  }
}

export class NetworkException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'NetworkException';
  }
}

export class PermissionException extends ValidationException {
  constructor(message?: string) {
    super(message);
    this.name = 'PermissionException';
  }
}

export class HttpException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'HttpException';
  }
}

export class TimeoutHttpException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'TimeoutHttpException';
  }
}

export class DependantSyncActionException extends Error {
  constructor(record: any) {
    super(DependantSyncActionException.createMessage(record));
  }

  private static createMessage(record: any): string {
    if (record) {
      return `Sync action failed due to the online Id of record not being populated on upload.`;
    }
    else {
      return `$Sync action failed due to record not existing on upload.`;
    }
  }
}

export class AggregateException extends Error {
  errors: Error[] = [];
  constructor(errors: Error[]) {
    super();
    this.errors = errors;
    this.name = 'AggregateException';
  }
}